module.exports = __webpack_public_path__ + "static/media/promothree.f1d4b3be.png";